import GroupOverview from './GroupOverview'

export default GroupOverview
